import React from 'react';
import './App.css';
import { BrowserRouter, Routes, Route, Link } from 'react-router-dom';
import HomePage from './pages/HomePage';
import TermsPage from './pages/TermsPage';
import PrivacyPage from './pages/PrivacyPage';
import SupportPage from './pages/SupportPage';

function App() {
  return (
    <BrowserRouter>
      <div className="App">
        <main className="App-main">
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/terms-of-service" element={<TermsPage />} />
            <Route path="/privacy-policy" element={<PrivacyPage />} />
            <Route path="/support" element={<SupportPage />} />
          </Routes>
        </main>
        <footer className="App-navbar">
            <div className="navbar-container">
              <div className="navbar-logo" onClick={() => window.location.href = '/'}>
                <span>music4fun</span>
              </div>
              <nav className="navbar-menu">
                <Link className="nav-link" to="/">Home</Link>
                <Link className="nav-link" to="/terms-of-service">Terms of Service</Link>
                <Link className="nav-link" to="/privacy-policy">Privacy Policy</Link>
                <Link className="nav-link" to="/support">Support</Link>
              </nav>
            </div>
        </footer>
      </div>
    </BrowserRouter>
  );
}

export default App;